import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import contentReducer from "../features/content/contentSlice";
import commentReducer from "../features/comment/commentSlice";
import subjectReducer from "../features/subject/subjectSlice";
import progressReducer from "../features/progress/progressSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    content: contentReducer,
    comment: commentReducer,
    subject: subjectReducer,
    progress: progressReducer,
  },
});
